<template>
   <el-breadcrumb separator=" > ">
       <el-breadcrumb-item>
           <span>首页</span>
       </el-breadcrumb-item>
        <el-breadcrumb-item v-for="item in lists" :key="item.path">
            <span>{{item.meta.title}}</span>
        </el-breadcrumb-item>
    </el-breadcrumb>
</template>

<script>
export default {
    name:'BreadCrumb',
    data() {
        return {
            lists: [],
        }
    },
    created () {
        this.lists = this.$route.matched;
    },
    watch: {
        $route(to, from) {
            console.log(from);
            this.lists = to.matched
        }
    },
}
</script>
